import { createClientOnlyFn } from '@tanstack/react-start';

// Client-only: localStorage exists only in the browser. Calling these during prerendering throws
// instead of failing silently, so use them in effects or event handlers (or behind useHydrated).
// NOTE: the '@tanstack/react-start/client-only' file marker can't be used here, because components that are
// also rendered on the server import this module (they just don't call it there).

const get = createClientOnlyFn(<T>(key: string): T | null => {
  const item = localStorage.getItem(key);

  if (item === null) {
    return null;
  }

  try {
    return JSON.parse(item) as T;
  } catch {
    return null;
  }
});

const set = createClientOnlyFn(<T>(key: string, value: T): void => {
  localStorage.setItem(key, JSON.stringify(value));
});

const hasKey = createClientOnlyFn(
  (key: string): boolean => localStorage.getItem(key) !== null
);

const remove = createClientOnlyFn((key: string): void => {
  localStorage.removeItem(key);
});

const clear = createClientOnlyFn((): void => {
  localStorage.clear();
});

export const storage = { get, set, hasKey, remove, clear };
